import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { FnPositionResponse } from "../../models/dtos";

export const fnPositionsApi = createApi({
  reducerPath: "fnPostionsApi",
  baseQuery: baseAuthQuery("FnPositions"),
  tagTypes: ["FnPosition"],
  endpoints: (builder) => ({
    getFnPositions: builder.query<ApiResponse<FnPositionResponse[]>, void>({
      query: () => "",
      providesTags: ["FnPosition"],
    }),
    getFnPositionsById: builder.query<ApiResponse<FnPositionResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ["FnPosition"],
    }),
    updateFnPositions: builder.mutation<ApiResponse<FnPositionResponse>, Partial<FnPositionResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ["FnPosition"],
    }),
    deleteFnPositions: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ["FnPosition"],
    }),
  }),
});
